// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__duVBJ","icon":"Chat_icon__P9oC3","buttonContainer":"Chat_buttonContainer__+prGh","button":"Chat_button__Twgv8"};